import React from 'react'
import penguinGlassesImg from '@assets/images/mascot/penguin-glasses.png'
import penguinHeadPhoneImg from '@assets/images/mascot/penguin-headphone2.png'
import penguinLaptopImg from '@assets/images/mascot/penguin-laptop2.png'
import penguinPhoneImg from '@assets/images/mascot/penguin-pohne.png'
import penguinReadImg from '@assets/images/mascot/penguin-read.png'
import penguinImg from '@assets/images/mascot/penguin.png'
import { Button, IconButton, Link, Paper, Stack, Typography } from '@common/components'
import { MY_CLASSROOMS_ROUTE } from '@common/constants/routes'
import { ArrowBackIcon } from '@common/icons'

const HowItWorksEvent = (props: { topicLink?: string | null; onClose: () => void }) => {
  const [currentStepIndex, setCurrentStepIndex] = React.useState(0)
  const { onClose } = props
  const howItWorksSteps = [
    {
      title: 'What is this event?',
      img: penguinImg,
      text: (
        <>
          This a 1-hour speaking session where you practice in pairs! <br /> We host multiple events
          every day. See all event times{' '}
          <Link href={MY_CLASSROOMS_ROUTE} target='_blank' rel='noopener'>
            here
          </Link>
          .
        </>
      ),
    },
    {
      title: 'What happens here?',
      img: penguinHeadPhoneImg,
      text: (
        <>
          We'll match you with a new partner every 12 minutes for speaking practice.
          <br />
          Premium members get AI feedback.
        </>
      ),
    },
    {
      title: 'What will we talk about?',
      img: penguinGlassesImg,
      text: (
        <>
          You are invited to discuss{' '}
          {props.topicLink ? (
            <Link href={props.topicLink} target='_blank' rel='noopener'>
              today’s topic
            </Link>
          ) : (
            'today’s topic'
          )}
          .
          <br />
          You can also have a conversation about your shared interests.
        </>
      ),
    },
    {
      title: 'Can I join as a beginner?',
      img: penguinReadImg,
      text: (
        <>
          If you’re a beginner, we recommend you join the dedicated beginner sessions. You can
          filter for these on the
          <Link
            href='https://airtable.com/appLt40pqPhL2gIkf/shrdOg6nC7Z4qk1DU'
            target='_blank'
            rel='noopener'
          >
            events page
          </Link>
          ).
        </>
      ),
    },
    {
      title: 'Do I have to use my camera?',
      img: penguinPhoneImg,
      text: 'Everyone is required to keep their webcam on in the breakout rooms.',
    },
    {
      title: 'Can I meet the same person?',
      img: penguinLaptopImg,
      text: (
        <>
          If you enjoy the conversation, you can follow each other and we will match you together
          for practice more often.
          <br />
          Private messaging coming soon!
        </>
      ),
    },
  ]

  const currentStep = howItWorksSteps[currentStepIndex]
  const handleNext = () => {
    if (currentStepIndex < howItWorksSteps.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1)
    }
  }
  return (
    <>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ mb: 2, position: 'relative', width: '100%', maxWidth: '400px' }}
      >
        <IconButton
          sx={{ position: 'absolute', left: 0 }}
          onClick={() => {
            if (currentStepIndex > 0) {
              setCurrentStepIndex(currentStepIndex - 1)
            } else {
              onClose()
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5' textAlign={'center'} fontWeight={'bold'}>
          How it works
        </Typography>
      </Stack>
      <Paper elevation={2} sx={{ p: 2, width: '90%', maxWidth: '400px' }}>
        <Stack>
          <Typography variant='body1' textAlign={'left'} fontWeight={'bold'} sx={{ mt: 2 }}>
            {currentStep?.title}
          </Typography>
          <Typography textAlign={'start'}>
            <p>{currentStep?.text}</p>
          </Typography>
          <img
            src={currentStep?.img}
            alt={currentStep?.title}
            style={{ width: '50%', objectFit: 'cover', margin: '0 auto' }}
          />
        </Stack>
      </Paper>
      {currentStepIndex < howItWorksSteps.length - 1 ? (
        <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={handleNext}>
          Next
        </Button>
      ) : (
        <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={onClose}>
          Got it!
        </Button>
      )}
    </>
  )
}

export default HowItWorksEvent
